import { envIsBoolean } from 'awFeConsole/util/anyPlatform';

/**
 * CRUD JS object cache
 * */
export default class ObjectCache<T> {
  static cacheLog (...args: unknown[]) {
    if (envIsBoolean(process.env.IS_NUXT_CACHE_LOG_ENABLED)) {
      // eslint-disable-next-line no-console
      console.log(process.pid, ...args);
    }
  }

  private _id: string;
  private _separator: string;
  private _storage: Record<string, ObjectCacheStorage<T> | undefined>;

  constructor (id: string, separator: string) {
    this._id = `object_cache/${id}`;
    this._separator = separator;
    this._storage = {};
  }

  _getCacheKey (keyParts: string | string[]) {
    return (
      typeof keyParts === 'string'
        ? keyParts
        : keyParts.join(this._separator)
    );
  }

  _ttlExpired (data?: { ttl: Date }) {
    return !data?.ttl || data.ttl < new Date();
  }

  initCache (keyParts: string | string[], cb: () => (T | undefined)) {
    const CACHE_KEY = this._getCacheKey(keyParts);
    ObjectCache.cacheLog(CACHE_KEY, 'ttl', !!this._storage[CACHE_KEY], this._storage[CACHE_KEY]?.ttl, this._ttlExpired(this._storage[CACHE_KEY]));
    if (!this._storage[CACHE_KEY] || this._ttlExpired(this._storage[CACHE_KEY])) {
      this.updateCache(keyParts, cb);
    }
  }

  updateCache (keyParts: string | string[], cb: () => (T | undefined)) {
    const CACHE_KEY = this._getCacheKey(keyParts);
    this._storage[CACHE_KEY] = new ObjectCacheStorage(`${this._id}/${CACHE_KEY}`, cb());
    ObjectCache.cacheLog(CACHE_KEY, 'Update new ttl ->', this._storage[CACHE_KEY].ttl);
  }

  deleteCache (keyParts: string | string[]) {
    const CACHE_KEY = this._getCacheKey(keyParts);
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this._storage[CACHE_KEY];
  }

  getCache (keyParts: string | string[]) {
    const CACHE_KEY = this._getCacheKey(keyParts);
    return this._storage[CACHE_KEY];
  }
}

class ObjectCacheStorage<T> {
  private _id: string;
  public ttl: Date;
  public value: T | undefined;
  constructor (id: string, value: T | undefined) {
    this._id = `object_cache_storage?id=${id}`;
    const nuxtCleanCacheInMinutes = parseInt(process.env.CLEAN_NUXT_CACHE_IN_MINUTES || '10');
    const createdTtl = new Date();
    createdTtl.setMinutes(createdTtl.getMinutes() + nuxtCleanCacheInMinutes);
    this.ttl = createdTtl;
    this.value = value;
  }
}
